import React from "react";
import Icon, { ICONS } from "@/components/Core/Icons";
import AppHeader from "@/components/AppHeader/AppHeader";
import { GitHubLogoIcon } from "@radix-ui/react-icons";

const GithubSuccess: React.FC = () => {
  return (
    <div className="flex flex-col h-full">
      <AppHeader hideCreateProject={true} />
      <div className="flex flex-col items-center justify-center grow text-center">
        <div className="flex items-center mb-12">
          <div className="bg-background-secondary p-2.5 rounded-lg">
            <Icon icon={ICONS.TEMPO_LOGO_WHITE} className="w-7 h-7" />
          </div>
          <div className="flex items-center mx-4">
            <div className="w-1.5 h-1.5 bg-primary-0 rounded-full"></div>
            <div className="mx-1.5 w-5 h-px bg-primary-0"></div>
            <div className="w-1.5 h-1.5 bg-primary-0 rounded-full"></div>
          </div>
          <div className="p-2.5 rounded-lg bg-background-secondary">
            <GitHubLogoIcon className="w-7 h-7" />
          </div>
        </div>
        <h1 className="text-lg font-bold mb-6">You're signed in to Tempo</h1>
        <p className="text-xs text-text-secondary">
          You can close this window.
        </p>
      </div>
    </div>
  );
};

export default GithubSuccess;
